import { initSessionDuration } from 'application/session_duration'
import { pushEventToGTMDataLayer } from 'application/gtm_utils'

import 'application/application'
import 'shared/flexible_header'
import 'application/ajax'
import 'application/bind_global_dom_events'
import 'application/recaptcha'
import 'application/messaging'
import 'application/popups'
import 'application/utils'

import '@fancyapps/fancybox'
import 'shared/form_material_design'
import 'shared/go_to_top'
import 'shared/flash_message'
import 'shared/breadcrumbs_flexible'
import 'shared/smart_search'
import 'shared/pingator'
import 'shared/promotion_modal'
import 'application/soft_update'
import 'application/standard_tracking'
import 'application/tracking_link_and_toggle'
import 'application/tracking_form'
import { loginEvent } from '../application/ga_login_event'
import { studentExpired } from '../application/ga_student_expired'

SOPHIA.loginEvent = loginEvent
SOPHIA.studentExpired = studentExpired
SOPHIA.pushEventToGTMDataLayer = pushEventToGTMDataLayer

initSessionDuration()
